import React from "react";

const MockConfirm = ({
    title,
    message,
    onConfirm,
    onCancel,
    confirmLabel = "Yes",
    cancelLabel = "No",
}) => (
    <div className="clk-mk-confirm-overlay" onClick={onCancel} role="presentation">
        <div
            className="clk-mk-confirm-body"
            onClick={(e) => e.stopPropagation()}
            role="alertdialog"
            aria-modal="true"
            aria-labelledby="clk-mk-confirm-title"
        >
            <h1 id="clk-mk-confirm-title">{title}</h1>
            {message && <p>{message}</p>}
            <div className="clk-mk-confirm-button-group">
                <button type="button" onClick={onConfirm}>{confirmLabel}</button>
                <button type="button" onClick={onCancel}>{cancelLabel}</button>
            </div>
        </div>
    </div>
);

export default MockConfirm;
